import React from "react";
import { Modal, Button } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import toast from "react-hot-toast";
const host = process.env.REACT_APP_API_SERVER

const MeetingExtend = ({ show, onCancel, data, onExtendSuccess }) => {
    // ✅ Validation schema
    const validationSchema = Yup.object().shape({
        hrs: Yup.number().required("Hours is required").min(0),
        mins: Yup.number().required("Minutes is required").min(0),
    }).test(
        "not-zero",
        "Duration cannot be 0 hours and 0 minutes",
        (values) => values && !(values.hrs === 0 && values.mins === 0)
    );


    const handleSubmit = (values) => {
        const formData = { ...data, ...values }
        // console.log("Meeting Extend Data:", { ...data, ...values });
        try {

            // setSubmitting(true);
            const authToken = localStorage.getItem('tutor-token');
            let config = {
                headers: {
                    "x-auth-token": authToken,
                },
            };
            axios.post(`${host}/api/tutor/meeting-time-extend`, formData, config)
                .then(res => {
                    if (res.status === 200) {
                        toast.success(res.data.message);
                        onCancel()
                        console.log('res', res.data.duration)
                        const extraMinutes = res.data.duration || 0;  // backend tells us what got added
                    
                        if (extraMinutes > 0) {
                            const newEndTime = new Date(data.end_time);
                            newEndTime.setMinutes(newEndTime.getMinutes() + extraMinutes);

                            if (typeof onExtendSuccess === "function") {
                                console.log("Calling onExtendSuccess with:", newEndTime, extraMinutes);
                                onExtendSuccess(newEndTime,extraMinutes);
                            }
                        }


                    } else {
                        toast.error(res.data.message);

                    }
                }).catch(err => {
                    if (err.response) {
                        toast.error(err.response.data.message);
                    } else {
                        toast.error("Internal server error.");
                    }

                });

        } catch (error) {
            console.log(error);
            toast.error(error.response?.data?.message || "Error occurred");

        }
    };

    return (
        <Modal show={show} onHide={onCancel} centered>
            <Modal.Body className="text-center p-4">
                <p className="mb-3 fw-semibold fs-5">
                    ⏳ Do you want to extend this meeting?
                </p>

                <Formik
                    initialValues={{ hrs: 0, mins: 0 }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ errors, touched }) => (
                        <Form>
                            <div className="mb-2">
                                <label htmlFor="duration" className="form-label fw-medium">
                                    Enter duration
                                </label>
                                <div className="input-group">
                                    <span className="input-group-text">
                                        <i className="bi bi-clock"></i>
                                    </span>

                                    {/* Hours Dropdown */}
                                    <Field
                                        as="select"
                                        name="hrs"
                                        className="form-select mb-0 shadow-none border"
                                    >
                                        {Array.from({ length: 2 }, (_, i) => (
                                            <option key={i} value={i}>
                                                {i} hour{i !== 1 ? "s" : ""}
                                            </option>
                                        ))}
                                    </Field>

                                    {/* Minutes Dropdown */}
                                    <Field
                                        as="select"
                                        name="mins"
                                        className="form-select mb-0 shadow-none border"
                                    >
                                        {[0, 15, 30, 45, 60].map((i) => (
                                            <option key={i} value={i}>
                                                {i} minute{i !== 1 ? "s" : ""}
                                            </option>
                                        ))}

                                    </Field>
                                </div>
                                {/* Validation Error */}
                                <ErrorMessage
                                    name="hrs"
                                    component="div"
                                    className="text-danger small mt-1"
                                />
                                <ErrorMessage
                                    name="mins"
                                    component="div"
                                    className="text-danger small mt-1"
                                />
                                {errors && touched && errors["not-zero"] && (
                                    <div className="text-danger small mt-1">
                                        {errors["not-zero"]}
                                    </div>
                                )}
                            </div>

                            <div className="d-flex justify-content-center gap-2 mt-3">
                                <Button variant="danger" onClick={onCancel}>
                                    Cancel
                                </Button>
                                <Button variant="success" type="submit">
                                    Submit
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
};

export default MeetingExtend;
